import React from 'react';
import DealerAd from '../DealerAd/DealerAd';
import { Platform } from '../DealerAd/types';
import {
  ThemeContext,
  ThemeOptions,
  ThemeSkin,
  ThemeSkinContext,
} from '@wix/da-react-context/pkg/ThemeContext';
import './App.scss';

const App: React.FC = () => {
  if (!window.location.search) {
    return null;
  }
  const params = new URLSearchParams(window.location.search);

  let theme = ThemeOptions.DARK;
  if (params.get('theme') === 'light') {
    theme = ThemeOptions.LIGHT;
  }
  if (params.get('theme') === 'dark') {
    theme = ThemeOptions.DARK;
  }
  if (params.get('theme') === 'green') {
    theme = ThemeOptions.LIGHT;
  }

  return (
    <ThemeSkinContext.Provider
      value={params.get('theme') === 'green' ? ThemeSkin.GREEN : undefined}
    >
      <ThemeContext.Provider value={theme}>
        <DealerAd
          platform={(params.get('platform') ?? 'desktop') as Platform}
          realEstateId={params.get('realEstateId') || ''}
          theme={params.get('theme') || 'dark'}
          width={parseInt(params.get('width') || '', 10)}
          height={parseInt(params.get('height') || '', 10)}
          userGuid={params.get('userGuid') || ''}
          biClientId={params.get('biClientId') || ''}
          biClientIdSigned={params.get('biClientIdSigned') || ''}
          withCloseButton={!!params.get('withCloseButton')}
        />
      </ThemeContext.Provider>
    </ThemeSkinContext.Provider>
  );
};

export default App;
